import React from 'react';

import { Autocomplete, TextField } from '@mui/material';
import { Filter } from '@models/feature-descriptor';
import { Unset } from '@utils';

export const FilterTypeSelector = (props: {
  types?: Filter.Type[];
  selectedType: Filter.Type | Unset;
  onTypeChange: (type: Filter.Type) => void;
  onBlur?: () => void;
}) => {
  return (
    <Autocomplete
      options={props.types ?? getDefaultOptions()}
      value={props.selectedType!}
      size="small"
      autoComplete
      blurOnSelect
      openOnFocus
      forcePopupIcon={false}
      onBlur={props.onBlur}
      disableClearable={true}
      onChange={(e, value) => value && props.onTypeChange(value)}
      renderInput={params => (
        <TextField {...params} variant="standard" autoFocus={true} />
      )}
    />
  );
};

function getDefaultOptions() {
  return Object.values(Filter.Type);
}
